import {
  IMessage,
  IUser,
  IUserChat,
  ReactionEmoji,
  Reactions,
} from '@/types/models';

export const uidToId = (uid?: string) => {
  if (!uid) {
    return null;
  }
  return +uid.split(/users-/g)[1];
};

export const idToUid = (id: number) => `users-${id}`;

export const buildCompanyTeamMap = (
  companyTeam: IUser[] | null | undefined
): Map<number, IUser> => {
  const map = new Map<number, IUser>();
  companyTeam?.forEach((teamUser) => map.set(teamUser.id, teamUser));
  return map;
};

export const getTeamUserByUid = (
  companyTeamById: Map<number, IUser>,
  uid: string
): IUser | undefined => {
  const id = uidToId(uid);
  return id != null ? companyTeamById.get(id) : undefined;
};

export const filterChatUsersBySearch = <T extends { user: IUserChat }>(
  items: T[] | null | undefined,
  companyTeamById: Map<number, IUser>,
  search: string
): T[] | null => {
  if (!items) {
    return null;
  }

  const query = search.trim().toLowerCase();
  if (!query) {
    return items;
  }

  return items.filter(({ user }) => {
    const teamUser = getTeamUserByUid(companyTeamById, user.uid);
    const fullName = `${teamUser?.firstName || ''} ${teamUser?.lastName || ''}`
      .trim()
      .toLowerCase();
    const firstName = (teamUser?.firstName || '').toLowerCase();
    const lastName = (teamUser?.lastName || '').toLowerCase();
    const jobTitle = (teamUser?.jobTitle || '').toLowerCase();

    return (
      fullName.includes(query) ||
      firstName.includes(query) ||
      lastName.includes(query) ||
      jobTitle.includes(query)
    );
  });
};

export const getReactionsFromMessage = (
  message: IMessage
): Reactions | null => {
  const metadata = message.data.metadata;
  if (metadata != null) {
    const injectedObject = metadata['@injected'];
    if (injectedObject != null && injectedObject.hasOwnProperty('extensions')) {
      const extensionsObject = injectedObject['extensions'];
      if (
        extensionsObject != null &&
        extensionsObject.hasOwnProperty('reactions')
      ) {
        return extensionsObject['reactions'];
      }
    }
  }
  return null;
};

export const getCountReactions = (reactions: Reactions): number | null => {
  let totalUsers = 0;

  for (const reaction in reactions) {
    const users = reactions[reaction as ReactionEmoji];
    if (users) {
      totalUsers += Object.keys(users).length;
    }
  }

  return totalUsers ? totalUsers : null;
};

export const getMyReaction = (
  reactions: Reactions,
  userId: number
): ReactionEmoji | null => {
  for (const reaction in reactions) {
    const users = reactions[reaction as ReactionEmoji];
    if (users && users[idToUid(userId)]) {
      return reaction as ReactionEmoji;
    }
  }
  return null;
};
